// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605122333/js/" + chunkId + "." + {"44":"0ca03249","225":"8ad44eb1","481":"31619037","486":"17d70b6b","770":"50836a10"}[chunkId] + ".0.1612952850179057.chunk.js";
};